import type { SerializedStyles } from '@emotion/react';
import {
  Title as DSTitle,
  Group,
  type GroupProps,
  Text,
  desktopFirstMediaQuery,
} from '@inflearn/ds-react-next';
import { useTranslation } from 'next-i18next';
import type { ReactNode } from 'react';

import { formatCommaNumber } from '../../../../utils/format/number';

export default function SectionHeader({
  children,
  styles,
  align = 'flex-start',
  justify = 'space-between',
}: {
  children: ReactNode;
  styles?: SerializedStyles;
  justify?: GroupProps['justify'];
  align?: GroupProps['align'];
}) {
  return (
    <Group
      wrap="nowrap"
      mb={12}
      align={align}
      justify={justify}
      styles={{
        root: {
          marginTop: 20,

          [desktopFirstMediaQuery.tablet]: {
            marginTop: 0,
          },

          [desktopFirstMediaQuery.mobile]: {
            gap: 10,
            marginTop: 20,
          },

          ...styles,
        },
      }}
    >
      {children}
    </Group>
  );
}

function Title({ title, children }: { title: string; children?: ReactNode }) {
  if (!children) {
    return (
      <DSTitle
        order={2}
        size={20}
        styles={{
          root: {
            whiteSpace: 'nowrap',
            [desktopFirstMediaQuery.mobile]: {
              fontSize: 18,
            },
          },
        }}
      >
        {title}
      </DSTitle>
    );
  }

  return (
    <Group wrap="nowrap" miw={0} gap={0}>
      <DSTitle
        order={2}
        size={20}
        styles={{
          root: {
            whiteSpace: 'nowrap',
            [desktopFirstMediaQuery.mobile]: {
              fontSize: 18,
            },
          },
        }}
      >
        {title}
      </DSTitle>
      {children}
    </Group>
  );
}

function TotalCount({ totalCount }: { totalCount: number }) {
  const { t } = useTranslation();

  return (
    <Text ml={8} size="sm" fw={500} c="gray.7" component="span">
      {t('전체', { context: 'TOTAL' })}{' '}
      <Text component="b" fw={700} c="infgreen.6" ml={2}>
        {formatCommaNumber(totalCount)}
      </Text>
    </Text>
  );
}

SectionHeader.Title = Title;
SectionHeader.TotalCount = TotalCount;
